import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { Guid } from 'tessa/platform';
import { CdUIHelper } from '../CdUIHelper';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { showError } from 'tessa/ui';

export class CdDocumentIDPUIExtension extends CardUIExtension {

  private _disposerPartner: Function | null = null;
  private _disposerObjects: Function | null = null;

  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.ArDocumentIdpTypeID)) {
      return;
    }

    // TODO кажется это что то лишнее
    // // Таблица "Контрагенты"
    // ArUIHelper.InitializeTablePartners(context, _disposer);

    // Заполнение виртуальных полей (Дата договора, таблицы: Объекты, Контрагенты)
    CdUIHelper.FillingUpVirtualInfoArDocumentIDP(context);

    // Таблица "Объект"
    CdUIHelper.InitializeTableObjects(context);

    // Заполнение Веха БОП
    CdUIHelper.FillingUpVehaBOP(context);

    // let partnersTableAlias = "DocumentsIDPPartners";
    // const partnersGrid = context.model.controls.get(partnersTableAlias) as GridViewModel;
    // if (partnersGrid != null) {
    //   this._disposerPartner = reaction(() => partnersGrid.selectedRow, row => {
    //     if (row == null) return;
    //     let isVirtual = row.row.tryGet("IsVirtual", false);
    //     if (isVirtual) {
    //       context.model.card.permissions.sections.getOrAdd("ArDocumentsIDPPartners").setSectionPermissions(CardPermissionFlags.ProhibitDeleteRow);
    //     }
    //     else {
    //       context.model.card.permissions.sections.getOrAdd("ArDocumentsIDPPartners").setSectionPermissions(CardPermissionFlags.AllowDeleteRow);
    //     }
    //   });
    // }

    // let objectsTableAlias = "Objects";
    // const objectsGrid = context.model.controls.get(objectsTableAlias) as GridViewModel;
    // if (objectsGrid != null) {
    //   this._disposerObjects = reaction(() => objectsGrid.selectedRow, row => {
    //     if (row == null) return;
    //     let isVirtual = row.row.tryGet("IsVirtual", false);
    //     if (isVirtual) {
    //       context.model.card.permissions.sections.getOrAdd("PkObjectList").setSectionPermissions(CardPermissionFlags.ProhibitDeleteRow);
    //     }
    //     else {
    //       context.model.card.permissions.sections.getOrAdd("PkObjectList").setSectionPermissions(CardPermissionFlags.AllowDeleteRow);
    //     }
    //   });
    // }
  }

  public async saving(context: ICardUIExtensionContext) {    
    if (context.model == null ||
      context.model.card == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.ArDocumentIdpTypeID)) {
      return;
    }
    const dciSection = context.model.card.sections.tryGet('DocumentCommonInfo');
    if (dciSection == null) return;

    let fullNumber = dciSection.fields.get("FullNumber");
    if (fullNumber == null) {
      await showError("Поле \"Номер\" обязательно для заполнения.");
      context.cancel = true;
      return;
    }

    let subject = dciSection.fields.get("Subject");
    if (!subject) {
      await showError("Поле \"Наименование\" обязательно для заполнения.");
      context.cancel = true;
      return;
    }
  }
   
  public finalized() {
    // подчищаем за собой
    if (this._disposerPartner) {
        this._disposerPartner();
        this._disposerPartner = null;
    }

    if (this._disposerObjects) {
      this._disposerObjects();
      this._disposerObjects = null;
  }
}

}